import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { TransactionFormComponent } from './shared/transaction-form/transaction-form.component';
import { TransactionEditComponent } from './transaction-edit/transaction-edit.component';
import { FormsService } from '../shared/forms.service';
import { TagService } from '../tags/shared/tag.service';
import { TransactionComponent } from './transaction.component';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    TagService,
    FormsService
  ],
  declarations: [ TransactionComponent, TransactionFormComponent, TransactionEditComponent]
})
export class TransactionModule { }



// WEBPACK FOOTER //
// ./src/app/transaction/transaction.module.ts